// extracted by mini-css-extract-plugin
module.exports = {"hl":"SectionLabel_hl__3jzkN","label":"SectionLabel_label__25GTJ","container":"SectionLabel_container__3cEy1"};